import React, { useContext } from 'react';
import { Segment } from 'semantic-ui-react';
import styled from 'styled-components';
import { ConsultationsConsumerRenderProps, ConsultationsContext } from '../consultations/ConsultationsContext';
import ProceduresInfo from 'components/procedures/ProceduresInfo';
import { MessageSourceProps, withMessages } from "react-message-source";
import { TreatmentsConsumerRenderProps, TreatmentsContext } from 'components/treatments/TreatmentsContext';
import HomeRightHeader from 'components/layout/HomeRightHeader';
import { PatientConsumerRenderProps, PatientContext } from 'components/patient/PatientContext';

const StyledProcedures = styled(Segment)`
  margin: 10px;
  height: 330px;
`;

const Procedures = (props: MessageSourceProps) => {

  const { selectedTreatment }: TreatmentsConsumerRenderProps = useContext(TreatmentsContext);
  const { selectedConsultation }: ConsultationsConsumerRenderProps = useContext(ConsultationsContext);
  const { currentPatient }: PatientConsumerRenderProps = useContext(PatientContext);

  return (
      <StyledProcedures>
        <HomeRightHeader>{props.getMessage('procedures')}</HomeRightHeader>
        <ProceduresInfo selectedConsultation={selectedConsultation}
                        selectedTreatment={selectedTreatment}
                        currentPatient={currentPatient}
        />
      </StyledProcedures>
  )
};

export default withMessages(Procedures);
